import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NavigationService } from '../../services/navigation.service';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  standalone: true,
  imports: [MatIcon, CommonModule, MatButtonModule]
})
export class BackButtonComponent {
  /**
   * Optional URL to navigate to when the back button is clicked. If not provided,
   * the button will navigate to the previous page in the browser history.
   */
  @Input() url?: string;

  constructor(
    public navigation: NavigationService,
    private router: Router
  ) {}

  onClick() {
    if (this.url) {
      this.router.navigate([this.url]);
    } else {
      this.navigation.goBack();
    }
  }
}
